import {
  COMPANY_ADDRESS_FULL,
  COMPANY_CITY,
  COMPANY_NAME,
  COMPANY_STATE,
  HERO_TAGLINE,
  PROFILE_SUMMARY,
  SOURCE_LABEL,
} from '../constants';

function HeroSection() {
  return (
    <section className="document-grid relative overflow-hidden bg-paper-wash text-fd-ink">
      <div className="absolute inset-x-0 top-0 h-2 bg-fd-ink" />
      <div className="relative mx-auto grid max-w-7xl justify-center gap-16 px-5 py-16 md:grid-cols-[minmax(0,620px)_minmax(420px,560px)] md:items-center lg:gap-28 lg:py-24">
        <div className="mx-auto w-full max-w-[620px]">
          <p className="text-xs font-black uppercase tracking-[0.28em] text-fd-blue">
            Company source record
          </p>
          <h1 className="mt-7 max-w-full font-serif text-5xl font-black uppercase leading-[0.9] tracking-[0.06em] text-fd-ink sm:text-6xl lg:text-[4.25rem] xl:text-[4.75rem]">
            {COMPANY_NAME}
          </h1>
          <p className="mt-8 max-w-2xl text-2xl font-bold leading-tight text-fd-ink sm:text-3xl">
            {HERO_TAGLINE}
          </p>
          <p className="mt-5 max-w-2xl text-base leading-8 text-fd-stone">{PROFILE_SUMMARY}</p>
          <div className="mt-10 grid max-w-2xl gap-3 sm:grid-cols-2">
            <a href="#profile" className="border-2 border-fd-ink bg-fd-ink px-6 py-3 text-center font-black text-fd-ivory shadow-document transition hover:bg-fd-paper hover:text-fd-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-fd-blue focus-visible:ring-offset-2 focus-visible:ring-offset-fd-ivory">
              Read source
            </a>
            <a href="#location" className="border-2 border-fd-ink bg-fd-paper px-6 py-3 text-center font-black text-fd-ink transition hover:border-fd-blue hover:text-fd-blue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-fd-blue focus-visible:ring-offset-2 focus-visible:ring-offset-fd-ivory">
              Company address
            </a>
          </div>
        </div>
        <aside className="mx-auto w-full max-w-xl bg-fd-paper p-4 shadow-document">
          <div className="border-4 border-double border-fd-ink p-6 text-center">
            <div className="barcode-mark mx-auto h-14 w-72 max-w-full" />
            <p className="mt-8 font-serif text-4xl font-black uppercase tracking-[0.28em]">Company</p>
            <p className="mt-2 font-serif text-2xl font-black uppercase tracking-[0.32em]">Record</p>
            <p className="mt-6 text-sm font-bold uppercase tracking-[0.18em] text-fd-stone">{SOURCE_LABEL}</p>
            <p className="mt-8 text-lg leading-8">Public-safe company profile for</p>
            <p className="mt-4 font-serif text-3xl font-black uppercase tracking-[0.12em]">{COMPANY_NAME}</p>
            <dl className="mt-8 grid gap-4 border-t border-fd-line pt-6 text-left sm:grid-cols-2">
              <div>
                <dt className="text-xs font-black uppercase tracking-wide text-fd-stone">Company</dt>
                <dd className="mt-1 font-bold">{COMPANY_NAME}</dd>
              </div>
              <div>
                <dt className="text-xs font-black uppercase tracking-wide text-fd-stone">Location</dt>
                <dd className="mt-1 font-bold">{COMPANY_CITY}, {COMPANY_STATE}</dd>
              </div>
            </dl>
          </div>
          <p className="mt-5 border border-fd-line bg-fd-ivory p-4 text-sm leading-6 text-fd-stone">
            {COMPANY_ADDRESS_FULL}
          </p>
        </aside>
      </div>
    </section>
  );
}

export default HeroSection;
